import axios from "axios";

export const APIFactory = axios.create({
  baseURL: process.env.REACT_APP_API_FACTORY_URL?process.env.REACT_APP_API_FACTORY_URL:"https://factory.wintics.com:5000/",
  responseType: "json"
});
// Setup config with token - helper function
export const tokenConfig = auth => {
  // Get token from state
  const token = auth.token;

  // Headers
  const config = {
    headers: {
      "Content-Type": "application/json"
    }
  };

  // If token, add to headers config
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }

  return config;
};
